<template>
    <r-e-dialog title="调拨资产" :visible.sync="dialogVisible" show-footer top="5vh" width="500px"
                @click-submit="clickSubmit" @click-cancel="clickCancel" @close="clickCancel">
        <el-form ref="formPublish" label-width="110px" size="small" :model="formPublish" :rules="rules">
            <div class="flex">
                <el-form-item label="资产名称">
                    <el-input v-model="asstesName" disabled style="width: 300px;" placeholder="请填写房型名称（15个字以内）"/>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item label="调出房间">
                    <el-input v-model="apartmentName" disabled style="width: 300px;" placeholder="请填写房型名称（15个字以内）"/>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item label="调入房间" prop="companyUuid">
                    <el-select v-model="formPublish.companyUuid" filterable style="width: 300px;" placeholder="请选择">
                        <el-option v-for="(item,index) in roomAllList" :key="index" :label="item.name"
                                   :value="item.uuid"/>
                    </el-select>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item label="说明" prop="remark">
                    <el-input type="textarea" v-model="formPublish.remark" :autosize="{ minRows: 2, maxRows: 4}"
                              style="width: 300px;" placeholder="请输入内容"/>
                </el-form-item>
            </div>
        </el-form>
    </r-e-dialog>
</template>

<script>
import {assetsAllocatePublish, allocateRoomAllList} from "@/api/assetTransfer";
import {MessageSuccess, MessageError} from "@custom/message";

export default {
    name: "dialog-asset-allocation",
    props: {
        currentHouse: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            dialogVisible: false,
            formPublish: {
                assetsUuid: '',
                companyUuid: '',
                oldCompanyUuid: '',
                remark: ''
            },
            rules: {
                companyUuid: [{required: true, message: '请选择调入房间', trigger: 'change'}],
                remark: [{required: true, message: '请输入说明', trigger: 'blur'}],
            },
            roomAllList: [],
            asstesName: '',
            apartmentName: '',
            loadingOptions: {
                lock: true,
                text: "Loading...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            },
        }
    },
    methods: {
        //打开资产调度弹框界面
        openDialog({assetsUuid, oldCompanyUuid, asstesName, apartmentName}) {
            //获取资产uuid
            this.formPublish.assetsUuid = assetsUuid;
            //获取旧房间uuid
            this.formPublish.oldCompanyUuid = oldCompanyUuid;
            //获取资产名称
            this.asstesName = asstesName;
            //获取旧房间名称
            this.apartmentName = apartmentName;
            //打开资产调度弹窗
            this.dialogVisible = true;
        },

        // 点击确认按钮事件
        clickSubmit() {
            let that = this;
            // 表单校验
            that.$refs["formPublish"].validate((valid) => {
                if (valid) {
                    const {loadingOptions} = that;
                    const loading = that.$loading(loadingOptions);
                    let {companyUuid, oldCompanyUuid, remark, assetsUuid} = that.formPublish;
                    let data = {companyUuid, oldCompanyUuid, remark, assetsUuid};
                    assetsAllocatePublish(data).then(res => {
                        MessageSuccess('调拨成功');
                        //调用取消按钮事件，关闭弹框
                        that.clickCancel();
                        loading.close();
                    }).finally(() => loading.close());
                }
            });
        },

        // 点击取消按钮事件
        clickCancel() {
            //重置数据
            this.$refs["formPublish"].resetFields();
            // 关闭弹窗
            this.dialogVisible = false;
        },
    },
    async mounted() {
        //调用接口，获取调度房间
        let roomAllListInfo = await allocateRoomAllList();
        this.roomAllList = roomAllListInfo.list;
    }
}
</script>

<style scoped>

</style>